import { render } from "./ValidationWarning.vue?vue&type=template&id=5c08d50e"
import script from "./ValidationWarning.vue?vue&type=script&lang=js"
export * from "./ValidationWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__